import{Typography}from"antd";import styled from"@emotion/styled";import{mediaQuery}from"@wp/src/components/common/grid";const{Paragraph,Text:WpText}=Typography;const WpParagraph=styled(Paragraph)`
  ${mediaQuery({marginBottom:["0.1em","0.2em","0.25em","0.5em","0.75em","1em"]})}
`;export{WpParagraph,WpText};